import api from "./api";

const PREFIX = "api/migration";

export const migrationService = {
  getMetadata: async (body) => {
    const response = await api.post(`${PREFIX}/metadata`, body);
    return response.data;
  },

  startMigration: async (body) => {
    const response = await api.post(`${PREFIX}/start`, body);
    return response.data;
  },

  getStatus: async (id) => {
    const response = await api.get(`${PREFIX}/${id}`);
    return response.data;
  },

  cancel: async (id) => {
    const response = await api.post(
      `${PREFIX}/${id}/cancel`,
      {},
      { timeout: 15000 },
    );
    return response.data;
  },

  getHistory: async (params = {}) => {
    const response = await api.get(`${PREFIX}/history`, { params });
    return response.data;
  },

  getLogs: async (id, params = {}) => {
    const response = await api.get(`${PREFIX}/${id}/logs`, { params });
    return response.data;
  },

  getFailureReport: async (id, params = {}) => {
    const response = await api.get(`${PREFIX}/${id}/failure-report`, {
      params,
    });
    return response.data;
  },

  uploadFile: async (file, clientId) => {
    const formData = new FormData();
    formData.append("file", file);
    if (clientId) formData.append("client_id", clientId);
    const response = await api.post(`${PREFIX}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
};

export default migrationService;
